var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbout1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "gridItem__media",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 1600,
    height: 1200,
    viewBox: "0 0 1600 1200",
    style: {
      baselineShift: 0,
      clipRule: "nonzero",
      color: "rgb(61, 61, 61)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      cursor: "auto",
      direction: "ltr",
      display: "block",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      font: "400 16px / 18.4px Lato, sans-serif",
      imageRendering: "auto",
      letterSpacing: "normal",
      marker: "none",
      overflow: "hidden",
      paintOrder: "normal",
      pointerEvents: "auto",
      shapeRendering: "auto",
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      textAnchor: "start",
      textDecoration: "none solid rgb(61, 61, 61)",
      textRendering: "auto",
      visibility: "visible",
      wordSpacing: 0,
      writingMode: "horizontal-tb"
    },
    fill: "none",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M443.5 217.9L208.6 604.7C204.2 610.6 201.9 617.8 201.9 625.1L301.9 990.8H1300.9L1390.9 656.5C1390.9 649.7 1388.9 643 1385 637.3L1154 219C1147.6 209.5 1136.9 203.8 1125.4 203.8H471.3C460.3 203.9 450 209.1 443.5 217.9Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M443.5 217.9L208.6 604.7C204.2 610.6 201.9 617.8 201.9 625.1L301.9 990.8H1300.9L1390.9 656.5C1390.9 649.7 1388.9 643 1385 637.3L1154 219C1147.6 209.5 1136.9 203.8 1125.4 203.8H471.3C460.3 203.9 450 209.1 443.5 217.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343.4 992.4H257.4C256.6 992.2 256 991.4 256.2 990.6C256.3 990 256.8 989.5 257.4 989.4H1343.4C1344.2 989.6 1344.8 990.4 1344.6 991.2C1344.5 991.8 1344 992.3 1343.4 992.4Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1343.4 992.4H257.4C256.6 992.2 256 991.4 256.2 990.6C256.3 990 256.8 989.5 257.4 989.4H1343.4C1344.2 989.6 1344.8 990.4 1344.6 991.2C1344.5 991.8 1344 992.3 1343.4 992.4Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M445.9 355.5C440.7 367.9 437.6 381 436.5 394.4H436L402.3 393.7H401.9V392.7C402 391.8 402.1 390.9 402.2 390.1C402.7 385.5 403.6 381 404.8 376.5C406.8 369.2 409.5 362.1 413 355.3C413.1 355 413.5 354.8 413.9 354.8C424.4 355 434.9 355.3 445.4 355.5H445.9Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M443.1 442.8H442.6L411.3 442.2C411 442.2 410.6 442 410.5 441.7C407 434 404.5 425.8 403.1 417.5C402.4 413.5 402 409.4 401.8 405.3C401.8 405.2 401.8 405 401.7 404.9V403.9H402.2L435.7 404.6C436.3 404.6 436.3 404.6 436.3 405.2C436.4 408 436.6 410.8 436.8 413.6C437.2 418 437.8 422.4 438.7 426.7C439.7 432 441.2 437.3 442.9 442.4C443 442.5 443 442.6 443.1 442.8Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M576.701 455.7C576.601 455.9 576.501 456 576.401 456.2C573.601 460.3 570.501 464.1 567.101 467.7C563.001 472.1 558.501 476.1 553.601 479.6C544.201 486.4 533.601 491.5 522.301 494.5C517.901 495.6 513.501 496.5 509.001 497L507.701 497.2H507.001L506.301 496.7L507.201 496.1C517.001 489.7 525.701 481.6 532.801 472.3C536.801 467 540.401 461.4 543.401 455.5C543.501 455.2 543.901 455 544.201 455L576.201 455.7H576.701Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M546.1 396.7L501.4 395.8L502.2 356.7C502.4 356.7 502.5 356.7 502.7 356.7L537.1 357.4C537.4 357.4 537.7 357.6 537.8 357.9C540.9 365.3 543.1 373 544.4 380.9C545.1 385 545.6 389.2 545.9 393.3C546 394.4 546 395.5 546.1 396.7Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M545.6 407.1C545.5 408 545.5 408.9 545.4 409.9C545.2 412.1 545 414.3 544.6 416.4C544.1 419.4 543.6 422.4 542.9 425.3C541.4 431.8 539.4 438.2 536.7 444.3C536.6 444.7 536.3 444.9 535.9 444.9C524.2 444.6 512.4 444.4 500.7 444.1H500.1L500.9 406.2L545.6 407.1Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M492.1 356.7L491.3 395.8L447.6 394.9C447.7 393.9 447.7 392.9 447.9 392C448.2 389.8 448.4 387.6 448.8 385.5C449.4 382.2 450 378.9 450.8 375.6C452.4 369 454.7 362.6 457.5 356.5C457.6 356.2 457.9 356 458.3 356L491.6 356.7H492.1Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M491.101 406.5C490.801 418.8 490.601 431 490.301 443.3V443.9H489.701C478.301 443.7 466.801 443.4 455.401 443.2C455.101 443.2 454.701 443 454.601 442.7C452.101 436.3 450.201 429.6 449.101 422.9C448.501 419.4 448.101 415.9 447.701 412.4C447.501 410.1 447.401 407.8 447.301 405.5C447.301 405.4 447.301 405.4 447.301 405.3C447.501 405.3 447.601 405.3 447.801 405.3L490.401 406.2C491.001 405.9 491.101 406 491.101 406.5Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M593.499 397.9L556.899 397.1C556.399 383.6 553.799 370.2 549.199 357.6H549.799L583.399 358.3C583.699 358.3 584.099 358.5 584.199 358.8C587.899 366.6 590.599 374.9 592.099 383.5C592.899 388.1 593.399 392.7 593.599 397.3C593.499 397.5 593.499 397.7 593.499 397.9Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M593.301 407.8C593.201 408.7 593.201 409.5 593.101 410.4C592.101 421.4 589.201 432.1 584.501 442.1C584.001 443.2 583.401 444.3 582.901 445.5C582.801 445.7 582.601 445.9 582.401 445.8C571.201 445.6 560.001 445.3 548.701 445.1H548.301C548.701 443.9 549.201 442.8 549.601 441.7C551.701 435.9 553.301 430 554.501 423.9C555.401 419.5 556.001 415.1 556.301 410.6C556.401 409.6 556.501 408.5 556.501 407.5C556.501 407.2 556.601 407.1 556.901 407.1C557.001 407.1 557.101 407.1 557.201 407.1L593.301 407.8Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M577.999 348.2C577.999 348.2 577.999 348.3 577.899 348.3H577.399L545.399 347.6C545.099 347.6 544.799 347.4 544.599 347.1C540.499 338.5 535.299 330.5 529.199 323.2C525.599 319 521.599 315.1 517.199 311.7C514.999 310 512.799 308.3 510.599 306.7L510.199 306.4L510.699 306.1C510.699 305.9 510.599 305.7 510.499 305.4C538.199 309.3 562.799 324.9 577.999 348.2Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M483 496.2C482.7 496.3 482.4 496.3 482.1 496.3C478.6 495.8 475.1 495 471.7 494.1C458 490.3 445.2 483.4 434.6 474C430.5 470.5 426.8 466.6 423.4 462.4C420.9 459.2 418.6 455.9 416.5 452.4L416.4 452.1H416.9C426.9 452.3 436.8 452.5 446.7 452.7C447 452.7 447.3 452.9 447.4 453.2C450.4 459.6 453.9 465.6 458 471.3C461.8 476.5 466 481.3 470.6 485.8C474.4 489.5 478.4 492.9 482.8 496C482.8 496.1 482.9 496.2 483 496.2Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M486.6 306C485.2 307 483.6 308.1 482 309.2C476.7 313.1 471.8 317.5 467.3 322.3C461.2 328.7 455.9 335.9 451.7 343.6C451.4 344.1 451.2 344.6 450.9 345.1C450.8 345.3 450.6 345.4 450.4 345.4C449.9 345.4 449.3 345.4 448.8 345.4L419.6 344.8C436.3 322.2 458.5 308.9 486.3 305.2L486.1 305.6L486.6 306Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M531.5 454.8C527.2 461.9 522.1 468.5 516.3 474.5C511.2 479.8 505.4 484.5 499.1 488.5L499.8 454.2L531.5 454.8Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M490.101 453.9L489.401 487.5C477.001 478.6 466.801 466.8 459.801 453.2L490.101 453.9Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M532.8 347.1L502.4 346.5L503.1 314.5C509.2 318.7 514.9 323.6 519.8 329.1C524.8 334.7 529.1 340.7 532.8 347.1Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M493 315.3L492.3 346.6L463.1 346C470.6 333.6 480.8 323 493 315.3Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.5 665.8C1258.7 644.1 1255.2 615.5 1243.6 600.8L1220.8 602.8C1230.5 609.9 1234.9 629.2 1227.5 638.7C1220.1 648.2 1202.8 652.7 1193.5 645C1186.2 639 1180.9 621.9 1171.5 622.9C1170.3 602.7 1151.1 585.2 1130.9 585.9C1121.9 567 1099.3 559 1080.5 568C1077.9 569.3 1075.4 570.8 1073.1 572.7L1072.1 649.1C1072.1 649.1 1085.6 671 1111.9 668.2C1118.8 667.5 1124.7 665.9 1129.3 661.9C1130 662.7 1130.8 663.4 1131.7 664C1135.3 666.1 1140 665.6 1143.7 663.7C1144.2 663.5 1144.6 663.2 1145.1 662.9C1152.6 674.5 1168.1 685.2 1180.6 688C1198.7 692.1 1228.5 680.1 1240.5 665.8Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1169.6 630.3C1169.6 630.2 1169.6 630.1 1169.6 630L1169.8 629C1169.9 628.6 1170 628 1170.1 627.4C1170.2 626.8 1170.3 626.1 1170.3 625.2C1170.7 620.5 1170.2 615.8 1168.7 611.4C1167.7 608.3 1166.4 605.4 1164.6 602.7C1162.6 599.6 1160.1 596.9 1157.2 594.6C1150.5 589.4 1142.1 586.8 1133.5 587.2C1132.3 587.2 1131.1 587.4 1129.9 587.6H1129.7L1129.6 587.4C1126.9 579.7 1121.7 573.2 1114.8 569C1113.3 568.1 1111.7 567.3 1110 566.6C1108.4 566 1106.8 565.4 1105.2 565C1102.3 564.2 1099.2 563.8 1096.2 563.7C1091.8 563.6 1087.4 564.4 1083.4 566.2C1082.8 566.5 1082.1 566.8 1081.6 567.1C1081.1 567.3 1080.7 567.6 1080.3 567.8L1079.5 568.3C1079.4 568.4 1079.3 568.4 1079.2 568.5C1079.2 568.5 1079.3 568.4 1079.4 568.3L1080.2 567.8C1080.6 567.5 1081.1 567.3 1081.5 567C1082.1 566.7 1082.7 566.3 1083.3 566.1C1087.3 564.2 1091.7 563.3 1096.2 563.4C1099.3 563.4 1102.3 563.9 1105.3 564.6C1107 565 1108.6 565.5 1110.2 566.2C1111.9 566.9 1113.5 567.7 1115.1 568.7C1122.1 573 1127.5 579.6 1130.2 587.3L1129.9 587.1C1139.7 585.5 1149.7 588.1 1157.5 594.2C1160.5 596.5 1163 599.3 1165 602.4C1166.8 605.1 1168.1 608.1 1169.1 611.2C1170.5 615.7 1171 620.4 1170.5 625.1C1170.4 625.9 1170.3 626.7 1170.2 627.3C1170.1 627.8 1170 628.4 1169.9 628.9L1169.7 629.9C1169.6 630.1 1169.6 630.2 1169.6 630.3Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1182.3 632.8C1182.2 632.8 1182.1 631.9 1181.5 630.6C1181.1 629.9 1180.7 629.2 1180.2 628.5C1179.6 627.7 1178.9 627 1178.1 626.4C1177.3 625.8 1176.4 625.3 1175.5 624.9C1174.7 624.6 1173.9 624.4 1173.1 624.2C1171.7 624 1170.8 624.1 1170.8 624C1171 623.9 1171.2 623.9 1171.4 623.9C1172 623.8 1172.5 623.8 1173.1 623.9C1174 624 1174.8 624.2 1175.6 624.5C1176.6 624.9 1177.5 625.4 1178.4 626C1179.2 626.6 1180 627.4 1180.6 628.2C1181.1 628.9 1181.5 629.6 1181.8 630.4C1182 630.9 1182.2 631.5 1182.2 632.1C1182.3 632.6 1182.4 632.8 1182.3 632.8Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1178.7 658.8C1178.7 658.8 1178.5 658.2 1178 657.2C1177.3 655.7 1176.3 654.4 1175.1 653.4C1173.3 651.8 1171 650.8 1168.6 650.5C1165.6 650.2 1162.6 651.1 1160.2 653L1159.9 653.3L1159.8 652.9C1159.5 651.6 1159.1 650.3 1158.5 649C1157 645.8 1154.6 643.1 1151.6 641.3C1149.2 639.8 1146.4 638.9 1143.5 638.6C1141.6 638.4 1139.6 638.6 1137.7 639C1136.4 639.3 1135.6 639.6 1135.6 639.5C1135.8 639.4 1135.9 639.3 1136.1 639.3C1136.6 639.1 1137.1 638.9 1137.6 638.8C1142.4 637.6 1147.5 638.3 1151.8 640.9C1154.9 642.8 1157.3 645.6 1158.9 648.8C1159.5 650.1 1160 651.4 1160.3 652.8L1159.9 652.6C1162.4 650.7 1165.5 649.8 1168.7 650.1C1171.2 650.3 1173.5 651.4 1175.4 653.1C1176.6 654.2 1177.6 655.6 1178.2 657.1C1178.4 657.5 1178.5 657.9 1178.6 658.3C1178.6 658.5 1178.7 658.7 1178.7 658.8Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1250.8 647.5C1250.8 647.8 1250.7 648 1250.6 648.3C1250.4 648.8 1250.2 649.6 1249.9 650.5C1248.9 653.2 1247.7 655.7 1246.2 658.2C1244 661.8 1241.4 665.2 1238.4 668.2C1236.7 670 1234.8 671.6 1232.9 673.2C1230.8 674.9 1228.7 676.5 1226.4 677.9C1218.5 683 1209.8 686.8 1200.7 689C1197.9 689.7 1195.1 690.1 1192.3 690.2C1191.3 690.2 1190.5 690.2 1190 690.2C1189.7 690.2 1189.5 690.2 1189.2 690.1C1189.5 690.1 1189.7 690.1 1190 690.1C1190.5 690.1 1191.3 690.1 1192.3 690C1195.1 689.8 1197.9 689.3 1200.7 688.6C1209.8 686.3 1218.4 682.6 1226.2 677.5C1228.4 676.1 1230.6 674.5 1232.6 672.8C1234.5 671.2 1236.4 669.6 1238.1 667.8C1241.1 664.8 1243.7 661.5 1245.9 658C1247.4 655.6 1248.7 653.1 1249.7 650.4C1250.1 649.5 1250.3 648.7 1250.5 648.2C1250.6 648 1250.7 647.7 1250.8 647.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1230.2 629C1230.3 629.4 1230.3 629.9 1230.2 630.3C1230.1 631.5 1229.9 632.7 1229.6 633.9C1227.5 641.9 1221 648 1212.9 649.7C1211.7 650 1210.5 650.1 1209.3 650.1C1208.9 650.1 1208.4 650.1 1208 650C1209.6 649.8 1211.3 649.6 1212.9 649.3C1220.8 647.5 1227 641.5 1229.3 633.8C1229.6 632.2 1230 630.6 1230.2 629Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M565.2 382.9H1104.2C1106.6 382.9 1108.5 384.8 1108.5 387.2V779.9C1108.5 782.3 1106.6 784.2 1104.2 784.2H565.2C562.8 784.2 560.9 782.3 560.9 779.9V387.2C560.9 384.8 562.8 382.9 565.2 382.9Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M565.2 382.9H1104.2C1106.6 382.9 1108.5 384.8 1108.5 387.2V779.9C1108.5 782.3 1106.6 784.2 1104.2 784.2H565.2C562.8 784.2 560.9 782.3 560.9 779.9V387.2C560.9 384.8 562.8 382.9 565.2 382.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.3 382.2H1104.7C1107.1 382.2 1109 384.1 1109 386.5V416.2H560V386.5C560 384.1 561.9 382.2 564.3 382.2Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.4 382.8H1098.4C1100.8 382.8 1102.7 384.7 1102.7 387.1V779.8C1102.7 782.2 1100.8 784.1 1098.4 784.1H559.4C557 784.1 555.1 782.2 555.1 779.8V387.1C555.1 384.7 557.1 382.8 559.4 382.8Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M559.4 382.8H1098.4C1100.8 382.8 1102.7 384.7 1102.7 387.1V779.8C1102.7 782.2 1100.8 784.1 1098.4 784.1H559.4C557 784.1 555.1 782.2 555.1 779.8V387.1C555.1 384.7 557.1 382.8 559.4 382.8Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1098.1 784.8H559.8C555.5 784.8 554.5 783.8 554.5 779.6V387.3C554.5 383.1 555.6 382.1 559.8 382.1H1098.1C1102.4 382.1 1103.4 383.1 1103.4 387.3V779.5C1103.5 783.7 1102.4 784.8 1098.1 784.8ZM559.8 383.5C556.3 383.5 555.9 383.9 555.9 387.3V779.5C555.9 782.9 556.3 783.3 559.8 783.3H1098.1C1101.6 783.3 1102 782.9 1102 779.5V387.3C1102 383.9 1101.6 383.5 1098.1 383.5H559.8Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1098.1 784.8H559.8C555.5 784.8 554.5 783.8 554.5 779.6V387.3C554.5 383.1 555.6 382.1 559.8 382.1H1098.1C1102.4 382.1 1103.4 383.1 1103.4 387.3V779.5C1103.5 783.7 1102.4 784.8 1098.1 784.8ZM559.8 383.5C556.3 383.5 555.9 383.9 555.9 387.3V779.5C555.9 782.9 556.3 783.3 559.8 783.3H1098.1C1101.6 783.3 1102 782.9 1102 779.5V387.3C1102 383.9 1101.6 383.5 1098.1 383.5H559.8Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.7 382.2H1099.1C1101.5 382.2 1103.4 384.1 1103.4 386.5V416.2H554.4V386.5C554.4 384.1 556.3 382.2 558.7 382.2Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.4 404.6C576.051 404.6 578.2 402.451 578.2 399.8C578.2 397.149 576.051 395 573.4 395C570.749 395 568.6 397.149 568.6 399.8C568.6 402.451 570.749 404.6 573.4 404.6Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.8 404.6C591.451 404.6 593.6 402.451 593.6 399.8C593.6 397.149 591.451 395 588.8 395C586.149 395 584 397.149 584 399.8C584 402.451 586.149 404.6 588.8 404.6Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.3 404.6C606.951 404.6 609.1 402.451 609.1 399.8C609.1 397.149 606.951 395 604.3 395C601.649 395 599.5 397.149 599.5 399.8C599.5 402.451 601.649 404.6 604.3 404.6Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.4 546.5H1006.6C1014 546.5 1020.1 552.5 1020.1 560V561.4C1020.1 568.8 1014.1 574.9 1006.6 574.9H651.4C644 574.9 637.9 568.9 637.9 561.4V560C637.9 552.5 643.9 546.5 651.4 546.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.5 546.5H977V574.8H1006.5C1013.9 574.8 1020 568.8 1020 561.3V559.9C1020 552.5 1014 546.5 1006.5 546.5Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988 568.1C987.7 567.8 987.799 567.4 988.099 567.1L993.7 562C994 561.8 994.399 561.8 994.599 562L995.299 562.8C995.599 563.1 995.499 563.5 995.299 563.8L989.599 568.9C989.299 569.1 988.9 569.1 988.7 568.8L988 568.1Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.3 552.1C1001 552.1 1001.7 552.2 1002.3 552.4C1005.6 553.5 1007.3 557.1 1006.1 560.4C1005.2 562.9 1002.9 564.6 1000.3 564.6C999.6 564.6 998.9 564.5 998.3 564.3C995 563.2 993.3 559.7 994.4 556.4C995.3 553.8 997.7 552.1 1000.3 552.1ZM1000.3 553.8C997.8 553.8 995.8 555.9 995.8 558.4C995.8 560.3 997 562 998.8 562.7C999.3 562.9 999.8 562.9 1000.3 562.9C1002.2 562.9 1004 561.7 1004.6 559.8C1005.4 557.4 1004.2 554.8 1001.8 554C1001.4 553.8 1000.8 553.7 1000.3 553.8Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.9 562.9C659.281 562.9 660.4 561.781 660.4 560.4C660.4 559.02 659.281 557.9 657.9 557.9C656.52 557.9 655.4 559.02 655.4 560.4C655.4 561.781 656.52 562.9 657.9 562.9Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.1 562.9C667.48 562.9 668.6 561.781 668.6 560.4C668.6 559.02 667.48 557.9 666.1 557.9C664.719 557.9 663.6 559.02 663.6 560.4C663.6 561.781 664.719 562.9 666.1 562.9Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.199 562.9C675.58 562.9 676.699 561.781 676.699 560.4C676.699 559.02 675.58 557.9 674.199 557.9C672.819 557.9 671.699 559.02 671.699 560.4C671.699 561.781 672.819 562.9 674.199 562.9Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.4 562.9C683.781 562.9 684.9 561.781 684.9 560.4C684.9 559.02 683.781 557.9 682.4 557.9C681.02 557.9 679.9 559.02 679.9 560.4C679.9 561.781 681.02 562.9 682.4 562.9Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.6 562.9C691.98 562.9 693.1 561.781 693.1 560.4C693.1 559.02 691.98 557.9 690.6 557.9C689.219 557.9 688.1 559.02 688.1 560.4C688.1 561.781 689.219 562.9 690.6 562.9Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.699 562.9C700.08 562.9 701.199 561.781 701.199 560.4C701.199 559.02 700.08 557.9 698.699 557.9C697.319 557.9 696.199 559.02 696.199 560.4C696.199 561.781 697.319 562.9 698.699 562.9Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.7 482.2H728.8C734.1 482.2 738.5 486.5 738.5 491.9V515.7C738.5 521 734.2 525.4 728.8 525.4H719.7C714.4 525.4 710 521.1 710 515.7V491.9C710.1 486.6 714.4 482.2 719.7 482.2Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.001 497H771.101C776.401 497 780.801 501.3 780.801 506.7V515.8C780.801 521.1 776.501 525.5 771.101 525.5H762.001C756.701 525.5 752.301 521.2 752.301 515.8V506.7C752.301 501.3 756.601 497 762.001 497Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.2 497H813.3C818.6 497 823 501.3 823 506.7V515.8C823 521.1 818.7 525.5 813.3 525.5H804.2C798.9 525.5 794.5 521.2 794.5 515.8V506.7C794.5 501.3 798.9 497 804.2 497Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.399 482.2H855.499C860.799 482.2 865.199 486.5 865.199 491.9V515.7C865.199 521 860.899 525.4 855.499 525.4H846.399C841.099 525.4 836.699 521.1 836.699 515.7V491.9C836.799 486.6 841.099 482.2 846.399 482.2Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.7 482.2C894.1 482.2 898.4 486.5 898.4 491.9V515.7C898.4 521 894.1 525.4 888.7 525.4C883.4 525.4 879 521.1 879 515.7V491.9C879 486.6 883.3 482.2 888.7 482.2Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.8 497H925.6C930.9 497 935.3 501.3 935.3 506.7V515.8C935.3 521.1 931 525.5 925.6 525.5H921.8C916.5 525.5 912.1 521.2 912.1 515.8V506.7C912.2 501.3 916.5 497 921.8 497Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.8 611.9H960.2C962 611.9 963.4 613.3 963.4 615.1V665.6C963.4 667.4 962 668.8 960.2 668.8H697.8C696 668.8 694.6 667.4 694.6 665.6V615.1C694.6 613.3 696 611.9 697.8 611.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.3 622.6H781.9V625.8H945.3V622.6Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.3 633.4H781.9V636.6H945.3V633.4Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.3 644.1H781.9V647.3H945.3V644.1Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.3 654.9H781.9V658.1H887.3V654.9Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M945.3 622.6H781.9V625.8H945.3V622.6Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M945.3 633.4H781.9V636.6H945.3V633.4Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M945.3 644.1H781.9V647.3H945.3V644.1Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M887.3 654.9H781.9V658.1H887.3V654.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.6 615.8H699.1V664.8H766.6V615.8Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M766.6 615.8H699.1V664.8H766.6V615.8Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M699.1 651.1L719 639.7L732.9 647.5L754.7 632.5L766.6 642V664.8H699.2L699.1 651.1Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M728 625.8C728 629 725.4 631.6 722.2 631.6C719 631.6 716.4 629 716.4 625.8C716.4 622.6 719 620 722.2 620C725.4 620 728 622.6 728 625.8Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.8 682.9H960.2C962 682.9 963.4 684.3 963.4 686.1V736.6C963.4 738.4 962 739.8 960.2 739.8H697.8C696 739.8 694.6 738.4 694.6 736.6V686.1C694.6 684.3 696 682.9 697.8 682.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.3 693.6H781.9V696.8H945.3V693.6Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.3 704.4H781.9V707.6H945.3V704.4Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.3 715.1H781.9V718.3H945.3V715.1Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.3 725.9H781.9V729.1H887.3V725.9Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M945.3 693.6H781.9V696.8H945.3V693.6Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M945.3 704.4H781.9V707.6H945.3V704.4Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M945.3 715.1H781.9V718.3H945.3V715.1Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M887.3 725.9H781.9V729.1H887.3V725.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.6 686.8H699.1V735.8H766.6V686.8Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M766.6 686.8H699.1V735.8H766.6V686.8Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.801 723.8C739.704 723.8 745.301 718.203 745.301 711.3C745.301 704.396 739.704 698.8 732.801 698.8C725.897 698.8 720.301 704.396 720.301 711.3C720.301 718.203 725.897 723.8 732.801 723.8Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737 711.3L733.8 713.2L730.5 715.1V711.3V707.6L733.8 709.5L737 711.3Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M737 711.3L733.8 713.2L730.5 715.1V711.3V707.6L733.8 709.5L737 711.3Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.499 911.7L725.299 931.8C724.699 932 723.999 931.6 723.899 930.9L697.899 820.8C697.699 820.2 698.099 819.5 698.799 819.4L762.699 804.3L790.299 820.4L811.499 910.2C811.499 910.9 811.099 911.5 810.499 911.7Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M810.499 911.7L725.299 931.8C724.699 932 723.999 931.6 723.899 930.9L697.899 820.8C697.699 820.2 698.099 819.5 698.799 819.4L762.699 804.3L790.299 820.4L811.499 910.2C811.499 910.9 811.099 911.5 810.499 911.7Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.6 804.3L790.2 820.4L768.8 825.4C768.2 825.6 767.5 825.2 767.4 824.5L762.6 804.3Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.4 917.7L808.7 896.8L812 910.6C812.1 911.1 811.8 911.6 811.3 911.7L724.9 932.1C724.4 932.2 723.9 931.9 723.8 931.4L720.4 917.7Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.699 881.8L752.299 881.7L751.199 843.9L755.599 844.1L756.699 881.8Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.901 877.5L726.801 869.9L739.201 853.9L742.701 856.6L733.801 868L746.601 873.4L744.901 877.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.599 871.9L765.199 869L774.299 858.5L761.199 852.2L763.099 848.3L781.399 857L768.599 871.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.6 839.2L1098.1 831.8C1098.1 831.5 1098 831.3 1097.7 831.2L1077.6 824.9C1077.3 824.8 1077 825 1076.9 825.3L1074.7 832.5L1051.3 906.9C1051.2 907.2 1051.3 907.5 1051.6 907.6L1154 939.8C1154.3 939.9 1154.6 939.7 1154.7 939.4L1177.9 865.6C1178 865.3 1177.9 865 1177.6 864.8L1098 839.8C1097.7 839.8 1097.6 839.5 1097.6 839.2Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.6 839.2L1098.1 831.8C1098.1 831.5 1098 831.3 1097.7 831.2L1077.6 824.9C1077.3 824.8 1077 825 1076.9 825.3L1074.7 832.5L1051.3 906.9C1051.2 907.2 1051.3 907.5 1051.6 907.6L1154 939.8C1154.3 939.9 1154.6 939.7 1154.7 939.4L1177.9 865.6C1178 865.3 1177.9 865 1177.6 864.8L1098 839.8C1097.7 839.8 1097.6 839.5 1097.6 839.2Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.6 839.2L1098.1 831.8C1098.1 831.5 1098 831.3 1097.7 831.2L1077.6 824.9C1077.3 824.8 1077 825 1076.9 825.3L1074.7 832.5L1051.3 906.9C1051.2 907.2 1051.3 907.5 1051.6 907.6L1154 939.8C1154.3 939.9 1154.6 939.7 1154.7 939.4L1177.9 865.6C1178 865.3 1177.9 865 1177.6 864.8L1098 839.8C1097.7 839.8 1097.6 839.5 1097.6 839.2Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1097.6 839.2L1098.1 831.8C1098.1 831.5 1098 831.3 1097.7 831.2L1077.6 824.9C1077.3 824.8 1077 825 1076.9 825.3L1074.7 832.5L1051.3 906.9C1051.2 907.2 1051.3 907.5 1051.6 907.6L1154 939.8C1154.3 939.9 1154.6 939.7 1154.7 939.4L1177.9 865.6C1178 865.3 1177.9 865 1177.6 864.8L1098 839.8C1097.7 839.8 1097.6 839.5 1097.6 839.2Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.9 874.6L1127.7 919.8L1185.8 836.6L1137.7 803L1109.9 807.2L1062.9 874.6Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1062.9 874.6L1127.7 919.8L1185.8 836.6L1137.7 803L1109.9 807.2L1062.9 874.6Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.7 803L1109.9 807.2L1126.6 818.9L1137.7 803Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1133.7 820.877L1132.21 823.01L1168.22 848.125L1169.71 845.992L1133.7 820.877Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1129.97 826.228L1128.48 828.36L1164.49 853.476L1165.97 851.343L1129.97 826.228Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1126.2 831.666L1124.71 833.799L1160.72 858.914L1162.21 856.781L1126.2 831.666Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1105.75 825.364L1104.26 827.496L1157.08 864.339L1158.57 862.207L1105.75 825.364Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1101.89 830.728L1100.4 832.86L1153.23 869.704L1154.71 867.571L1101.89 830.728Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1098.12 836.157L1096.64 838.289L1149.46 875.132L1150.95 873L1098.12 836.157Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1094.39 841.5L1092.9 843.633L1145.72 880.476L1147.21 878.344L1094.39 841.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1090.62 846.938L1089.13 849.07L1141.95 885.914L1143.44 883.781L1090.62 846.938Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1086.85 852.36L1085.36 854.492L1138.18 891.335L1139.67 889.203L1086.85 852.36Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1083.11 857.702L1081.62 859.835L1134.44 896.678L1135.93 894.546L1083.11 857.702Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1079.34 863.132L1077.85 865.265L1130.67 902.108L1132.16 899.975L1079.34 863.132Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1075.56 868.552L1074.07 870.685L1126.89 907.528L1128.38 905.395L1075.56 868.552Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.3 907.5L1153.7 939.7C1154 939.8 1154.3 939.6 1154.4 939.3L1168.6 869.5C1168.7 869.2 1168.5 868.9 1168.2 868.8L1086.9 843.2C1086.7 843.1 1086.5 842.9 1086.5 842.7L1086.2 835.6C1086.2 835.4 1086 835.2 1085.8 835.1L1067.3 829.3C1067 829.2 1066.7 829.4 1066.6 829.7L1050.9 906.8C1050.9 907.1 1051 907.4 1051.3 907.5Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1051.3 907.5L1153.7 939.7C1154 939.8 1154.3 939.6 1154.4 939.3L1168.6 869.5C1168.7 869.2 1168.5 868.9 1168.2 868.8L1086.9 843.2C1086.7 843.1 1086.5 842.9 1086.5 842.7L1086.2 835.6C1086.2 835.4 1086 835.2 1085.8 835.1L1067.3 829.3C1067 829.2 1066.7 829.4 1066.6 829.7L1050.9 906.8C1050.9 907.1 1051 907.4 1051.3 907.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.099 501.9L588.199 466.1L599.999 453.7C599.999 453.7 658.099 482.3 670.899 501.9L657.899 511.7L634.099 501.9Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.5 655.4L483.9 709.2L498.1 705.2L490.4 650.9L464.5 655.4Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.5 514L580.8 513.8C580.8 513.8 597.8 509.5 604.9 508.6L634.1 501.9C634.1 501.9 660.7 507.2 670.8 501.9C670.8 501.9 676.6 516.2 661.4 523.7L600 554.5L602.7 572.3C602.7 572.3 610.2 630.1 612.3 673.2L512.9 680.8L507.6 616.8L493.2 583L488.7 624.8L492.3 650.6L462.4 655.9L455.7 628C455.2 625.9 455 623.7 455.2 621.5L461.1 550C461.1 550 461.1 532.2 473.6 526L516.9 512.4L552.5 514Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.2 469.2C566.8 468.5 570.8 463.4 570.2 457.8C569.6 452.2 564.4 448.2 558.8 448.8C558.5 448.8 557.6 448.7 557.8 449C560.6 457.7 558.9 469.4 561.2 469.2Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.9 512.4C516.9 512.9 536.5 525.5 545.2 523.7C549.7 522.8 552.5 514.5 552.4 514L550 500.2V493.1C550.4 491.5 552.4 489.9 552.4 487.7C553 477.7 554.2 468.5 554.2 468.5C554.2 468.5 521.4 446.5 519.3 472.1L518.5 475.8L516.9 512.4Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M529.499 498C531.899 500.4 534.899 502.4 540.699 502.8C545.199 505.4 547.999 505.4 550.599 505.1L549.799 499.4C546.999 502.4 535.199 503.2 530.299 497.2C530.199 497 529.799 497 529.599 497.2C529.399 497.4 529.399 497.7 529.499 498Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.799 437.1C556.799 437.1 573.399 496.4 545.799 501.5C521.899 505.9 517.299 468.6 517.299 468.6L517.199 444.3L535.399 436L556.799 437.1Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550 452.2C546.9 448.5 542 446 537.1 446.5C531.5 447.1 527.3 451.9 528.4 458.3L528.6 459.7C528.8 461.1 527.9 462.3 526.6 462.6C524 462.9 522.2 465.1 522.4 467.7L522.9 471.9C522.9 472.4 522.6 472.9 522 472.9C522 472.9 520.8 473.2 520.5 472.2L519.5 467.7L521.8 441.7L542.6 434.4L552.1 441.2L550 452.2Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M517.699 473.9C517.699 473.9 519.199 478.9 520.399 476.6L518.599 481.1L517.699 473.9Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.101 485L538.801 483.3C538.901 485.9 540.801 488.1 543.401 488.5C548.801 489.5 550.101 485 550.101 485Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.699 467C537.399 467.1 536.499 468.2 536.599 469.5C536.699 470.8 537.799 471.7 539.099 471.6C540.399 471.5 541.299 470.4 541.199 469.1C541.099 467.8 539.999 466.9 538.699 467Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.93 468.996C540.151 468.978 540.314 468.785 540.297 468.565C540.279 468.345 540.086 468.181 539.866 468.199C539.645 468.217 539.481 468.41 539.499 468.63C539.517 468.85 539.71 469.014 539.93 468.996Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.501 934.2L539.001 934.1L534.801 972.1H512.301L512.501 934.2Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M512.5 972.4L512.6 945.5L537.9 945.4L537.5 948.6L521.3 951.1C519.8 951.3 518.6 952.6 518.5 954.1L518 965.8L512.5 972.4Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.999 963.7L511.899 965.9C511.899 967.8 511.499 969.7 510.899 971.4L508.099 979.2C507.299 981.4 506.899 983.7 506.999 986V986.4C507.099 988 508.399 989.2 509.999 989.2H537.599C539.199 989.3 540.499 988 540.599 986.4V985.4C540.599 983.4 540.299 981.4 539.699 979.5L537.299 971.6C536.799 970 536.499 968.3 536.499 966.6V963.7C536.499 961.9 535.799 960.1 534.499 958.8L534.099 958.3C528.799 952.9 520.199 952.8 514.799 958.1L514.099 958.8C512.899 960.1 512.099 961.9 511.999 963.7Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M507 984.3H540.5C540.6 984.7 540.6 985.1 540.6 985.5V986.5C540.5 988.1 539.2 989.3 537.6 989.3H510C508.4 989.4 507.1 988.1 507 986.5V984.3Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.2 964.9C530.3 964.6 530.2 964.2 529.9 964C526.3 962.2 522.1 962.2 518.4 964C518.1 964.2 517.9 964.6 518.1 964.9C518.3 965.2 518.7 965.4 519 965.2C522.2 963.7 525.9 963.7 529.2 965.2C529.3 965.3 529.4 965.3 529.5 965.3C529.8 965.3 530.1 965.2 530.2 964.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.2 968.5C530.3 968.2 530.2 967.8 529.9 967.6C526.3 965.8 522.1 965.8 518.4 967.6C518.1 967.8 517.9 968.2 518.1 968.5C518.3 968.8 518.6 969 519 968.8C522.2 967.3 525.9 967.3 529.2 968.8C529.3 968.9 529.4 968.9 529.5 968.9C529.8 968.9 530.1 968.7 530.2 968.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.2 971.9C530.3 971.6 530.2 971.2 529.9 971C526.3 969.2 522.1 969.2 518.4 971C518.1 971.2 517.9 971.6 518.1 971.9C518.3 972.2 518.7 972.4 519 972.2C522.2 970.7 525.9 970.7 529.2 972.2C529.3 972.3 529.4 972.3 529.5 972.3C529.8 972.3 530.1 972.2 530.2 971.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.301 936L619.401 935.9L620.101 950.9C620.301 954.8 622.201 958.4 625.401 960.7L644.501 974.4L596.601 973.2L593.301 936Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M610.499 967.2L617.399 969.9L596.499 972.2L594.199 946.8H619.699L619.899 949.8L604.599 952C602.999 952.2 601.799 953.7 601.899 955.4V955.7C602.399 960.8 605.699 965.3 610.499 967.2Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.099 962.7L606.299 965.9C607.799 966.4 609.399 966 610.599 965L618.599 958.1C620.399 956.5 623.099 956.5 624.899 957.9L642.999 972L657.299 976.7C661.499 978.1 664.399 982.1 664.399 986.5C664.399 987.8 663.399 988.8 662.099 988.8H598.699C595.699 988.8 593.299 986.4 593.199 983.4V964.7C593.199 963.5 594.199 962.5 595.399 962.6C595.699 962.6 595.899 962.6 596.099 962.7Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M593.301 984.3H664.201C664.401 985 664.501 985.8 664.501 986.6C664.501 987.9 663.501 988.9 662.201 988.9H598.701C596.001 988.9 593.801 986.9 593.301 984.3Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.001 965.3L628.801 961.2C629.001 961 629.001 960.6 628.801 960.4C628.601 960.2 628.201 960.2 628.001 960.4L624.201 964.5C624.001 964.7 624.001 965.1 624.201 965.3C624.301 965.4 624.401 965.4 624.601 965.5C624.701 965.4 624.901 965.3 625.001 965.3Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.001 967.6L631.801 963.5C632.001 963.3 632.001 962.9 631.801 962.7C631.601 962.5 631.201 962.5 631.001 962.7L627.201 966.8C627.001 967 627.001 967.4 627.201 967.6C627.301 967.7 627.401 967.8 627.601 967.8C627.701 967.8 627.901 967.7 628.001 967.6Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.001 970L634.801 965.9C635.001 965.7 635.001 965.3 634.801 965.1C634.601 964.9 634.201 964.9 634.001 965.1L630.201 969.2C630.001 969.4 630.001 969.8 630.201 970C630.301 970.1 630.401 970.1 630.601 970.1C630.801 970.1 630.901 970.1 631.001 970Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.601 470.8C557.871 470.8 558.901 469.77 558.901 468.5C558.901 467.23 557.871 466.2 556.601 466.2C555.331 466.2 554.301 467.23 554.301 468.5C554.301 469.77 555.331 470.8 556.601 470.8Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.524 467.996C557.744 467.978 557.908 467.785 557.89 467.565C557.872 467.345 557.679 467.181 557.459 467.199C557.239 467.217 557.075 467.41 557.093 467.63C557.111 467.85 557.304 468.014 557.524 467.996Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M549.6 481.6L546.7 481.9C546.4 481.9 546.1 481.7 545.9 481.3C545.9 481 546.1 480.7 546.5 480.5L549.4 480.2C550.1 480.1 550.6 479.5 550.5 478.8C550.3 478.1 549.7 477.5 549 477.7C548.7 477.7 548.4 477.5 548.2 477.1C548.1 476.8 548.5 476.5 548.8 476.3C550.2 476.1 551.6 477.1 551.8 478.6C552 480 551.1 481.3 549.7 481.6C549.7 481.6 549.6 481.6 549.6 481.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.6 452.4C510.9 445.8 513.9 440.7 519.5 439C521.9 438.3 524.4 438.2 526.8 438.7C527.7 438.9 528.6 438.4 528.8 437.5V437.4C529.5 432.9 533.2 429.5 537.8 429.1C540.9 428.8 544 430.1 546.1 432.5C546.7 433.2 547.7 433.3 548.4 432.7C548.5 432.7 548.5 432.6 548.5 432.6C548.5 432.6 554.7 426.8 563.8 431.5C570.2 435 572.9 442.7 570.1 449.4C567.1 456.6 558.2 459.4 552.2 454.6C549.7 452.5 548 449.4 547.7 446.1C547.2 443.8 547.3 441.5 547.8 439.2L544.9 439.4C541.5 439.5 536.1 439.3 531.1 440.4C531.2 440.5 531.3 440.5 531.4 440.6L522.7 444.3C522.7 444.3 521.8 468.3 520.4 468.2C513.8 467.4 510.3 458.3 510.6 452.4Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    style: {
      baselineShift: 0,
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M493.301 566C493.101 566 492.901 565.8 492.901 565.6C491.701 555.9 486.601 547 478.801 541.1C478.601 541 478.501 540.7 478.701 540.5C478.901 540.3 479.101 540.2 479.301 540.4C487.301 546.5 492.601 555.5 493.801 565.5C493.701 565.7 493.601 566 493.301 566Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M512.8 680.8L525.3 679.8L519.3 620.9C518.9 616.8 517.8 612.8 516 609L495.5 565.6L491.9 557.6L492.7 560.4C494.5 566.8 494.9 573.4 493.8 579.9L493.3 582.9L507.5 616.7L512.8 680.8Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M600 554.5L661.5 523.8C676.7 516.2 670.9 502 670.9 502C669.6 502.7 668.2 503.1 666.8 503.4C668.6 515.5 647.5 523.8 647.5 523.8L596.5 542.9L600 554.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.2 673.3L623.1 946.7H591L567.3 727C567.1 725.5 565.8 724.3 564.3 724.3C562.8 724.3 561.5 725.5 561.3 727L542.6 946.7H509L514.7 680.6L610.2 673.3Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M525.2 679.8L517.4 946.8H509L514.6 680.6L525.2 679.8Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    style: {
      baselineShift: 0,
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M599.999 554.9C599.799 554.9 599.599 554.8 599.599 554.6C599.599 554.4 594.699 538.1 592.999 534.7C592.899 534.5 592.899 534.2 593.099 534.1C593.299 534 593.599 534 593.699 534.2V534.3C595.499 537.8 600.199 553.7 600.399 554.4C600.499 554.6 600.299 554.9 600.099 554.9H599.999Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    style: {
      baselineShift: 0,
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M554.3 640.8C554.1 640.8 553.9 640.7 553.9 640.5C553.8 640.3 554 640 554.2 640C554.4 640 572.8 634.8 581.4 619C581.5 618.8 581.8 618.7 582 618.8C582.2 618.9 582.3 619.2 582.2 619.4C573.4 635.6 554.6 640.8 554.4 640.9L554.3 640.8Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    style: {
      baselineShift: 0,
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M479 625.2C478.8 625.2 478.7 625.1 478.6 624.9C478.5 624.7 478.6 624.4 478.8 624.3C482 622.9 488.6 624.2 488.9 624.3C489.1 624.3 489.3 624.6 489.2 624.8C489.2 625 488.9 625.2 488.7 625.1C488.6 625.1 482.1 623.8 479.2 625.1C479.1 625.2 479.1 625.2 479 625.2Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M546.199 456.1C546.199 456.1 543.299 463.7 561.199 461.2L560.799 458L554.199 454.3L546.199 456.1Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M564.4 724.4C565.9 724.4 567.2 725.5 567.4 727.1L591 946.8H601L576.7 730C575.5 721.2 564.4 724.4 564.4 724.4Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.699 710.7C567.399 701.9 539.799 715.2 530.899 740.5C522.099 765.8 535.399 793.4 560.699 802.3C585.999 811.1 613.599 797.8 622.499 772.5C631.299 747.2 617.999 719.5 592.699 710.7ZM563.199 795.1C541.899 787.6 530.599 764.3 538.099 743C545.599 721.7 568.899 710.4 590.199 717.9C611.499 725.4 622.799 748.7 615.299 770C607.899 791.3 584.599 802.5 563.199 795.1Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.499 713.4L537.099 736L533.599 746.1L468.999 723.5C467.099 722.8 466.199 720.8 466.799 719L467.999 715.7C468.599 713.8 470.599 712.8 472.499 713.4Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M576.7 799.6C600.559 799.6 619.9 780.259 619.9 756.4C619.9 732.542 600.559 713.2 576.7 713.2C552.841 713.2 533.5 732.542 533.5 756.4C533.5 780.259 552.841 799.6 576.7 799.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M535.799 756.4L593.999 719.5C593.999 719.5 608.499 726.6 614.699 740.8L542.499 778.4C542.399 778.4 535.199 767.6 535.799 756.4Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M547.9 785.3L617.6 750.3C617.6 750.3 618.1 760.4 615.9 767.5L558.5 793.3C558.4 793.5 551 788.8 547.9 785.3Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.201 448.2L582.001 447L571.101 443.7L561.501 445.3C561.001 445.5 560.801 446 560.901 446.5C561.201 447.6 561.901 449.1 564.001 448.4L556.901 448.9C556.401 449 555.901 449.3 555.801 449.9L555.601 450.5C555.401 451.5 557.901 452.5 559.001 452.5H559.601L553.301 452.8C552.701 453 552.401 453.6 552.601 454.2V454.3C552.901 455.1 553.401 456.1 553.701 456.2C554.001 456.3 549.201 456.8 547.401 457C547.101 457 546.801 457.3 546.801 457.6C546.801 457.7 546.801 457.7 546.801 457.8C547.201 458.9 548.601 460.8 553.701 460.8C560.901 460.7 563.501 459.5 563.501 459.5L569.201 461L568.901 464.4L561.101 464.3L561.401 468.7C562.501 469.2 571.401 470.2 571.401 470.2C571.401 470.2 583.401 470.4 586.601 468.8C589.801 467.2 592.201 466 592.201 466L601.101 454.4L586.201 448.2Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M570.199 459.8C570.199 459.8 576.399 456.2 579.099 451.7",
    stroke: "black",
    strokeWidth: 0.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    style: {
      baselineShift: 0,
      opacity: 0.15,
      paintOrder: "normal",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.67px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M561.699 464.6L572.599 464.8C572.599 464.8 577.399 459.6 582.399 460.7",
    stroke: "black",
    strokeWidth: 0.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    style: {
      baselineShift: 0,
      opacity: 0.15,
      paintOrder: "normal",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.67px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M554.199 456.8C554.199 456.8 561.699 456.7 564.599 454.7C564.599 454.7 566.199 456.7 570.199 456.6",
    stroke: "black",
    strokeWidth: 0.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    style: {
      baselineShift: 0,
      opacity: 0.15,
      paintOrder: "normal",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.67px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M559.5 452.6C562.1 452.4 564.6 451.9 567.1 451.3C568.8 452.8 571 453.6 573.2 453.8",
    stroke: "black",
    strokeWidth: 0.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    style: {
      baselineShift: 0,
      opacity: 0.15,
      paintOrder: "normal",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.67px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M563.1 448.8C565.4 448.9 567.7 448.5 569.8 447.7L574.6 449.9",
    stroke: "black",
    strokeWidth: 0.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    style: {
      baselineShift: 0,
      opacity: 0.15,
      paintOrder: "normal",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.67px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.801 704.8L504.401 716L508.501 725.6L502.301 724.1C502.301 724.1 499.701 736.8 498.601 737.1C497.501 737.4 494.601 736.4 494.901 734C494.001 734.9 492.801 735.3 491.601 735.1C489.701 734.7 489.301 733.5 489.501 731.2C489.501 731.2 488.601 733 486.001 731.9C484.401 731.2 484.801 728.9 484.801 728.9C484.801 728.9 482.001 729.1 481.601 727.7C481.201 725.3 481.101 722.9 481.501 720.5L483.201 712.4L483.801 707.2L497.801 704.8Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M484.801 728.9C485.301 727.3 485.601 725.6 485.701 723.9",
    stroke: "black",
    strokeWidth: 0.66,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    style: {
      baselineShift: 0,
      opacity: 0.15,
      paintOrder: "normal",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.66px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M489.301 731.1C489.901 729.2 490.301 727.2 490.501 725.3",
    stroke: "black",
    strokeWidth: 0.66,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    style: {
      baselineShift: 0,
      opacity: 0.15,
      paintOrder: "normal",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.66px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M494.9 734C495.6 731.6 496 729.2 496.3 726.7",
    stroke: "black",
    strokeWidth: 0.66,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    style: {
      baselineShift: 0,
      opacity: 0.15,
      paintOrder: "normal",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.66px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M542.7 946.8L543.2 941.9H509.1L509 946.8H542.7Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M590.5 941.9H622.9L623.1 946.8H591L590.5 941.9Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M470 654.5L485.7 708L482.7 721.1V728.7C482.7 728.7 481.5 729.1 481.4 726.1L481.3 721.9L481.6 719.7L483.6 708.6L464.5 655.5L470 654.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M461.2 550L455.2 621.5C455 623.7 455.2 625.8 455.7 628L462.4 655.9L470 654.6L462 625.3L467.8 542.6C467.8 542.6 468.1 531.9 475.1 525.7L473.6 526.2C461.2 532.2 461.2 550 461.2 550Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.099 463.1H553.399H551.999H543.499H532.399C530.599 463.1 529.199 464.5 529.199 466.3V468.8C529.199 473.6 533.099 477.6 537.999 477.6C542.899 477.6 546.799 473.7 546.799 468.8V466.3C546.799 465.6 546.599 464.9 546.099 464.3H549.499C548.999 464.8 548.799 465.6 548.799 466.3V468.8C548.799 473.6 552.699 477.6 557.599 477.6C562.499 477.6 566.399 473.7 566.399 468.8V466.3C566.199 464.6 564.799 463.2 563.099 463.1ZM545.499 466.4V468.9C545.299 473 541.899 476.2 537.799 476.1C533.899 476 530.799 472.8 530.599 468.9V466.4C530.599 465.4 531.499 464.5 532.499 464.5H543.599C544.599 464.6 545.399 465.4 545.499 466.4ZM564.999 468.9C564.799 473 561.399 476.2 557.299 476.1C553.399 476 550.299 472.8 550.099 468.9V466.4C550.099 465.3 550.999 464.5 551.999 464.5H553.299H562.999C564.099 464.5 564.899 465.4 564.899 466.4L564.999 468.9Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "mask-in-svg",
    style: {
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.801 476.5L519.001 465.6L529.101 477.5L524.901 490.7L515.801 476.5ZM519.301 468L516.801 476.4L524.601 488.1L528.001 477.6L519.301 468Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.8 475.5C527.8 475.5 544 481.4 562 478.9C562 478.9 560.3 496.1 548.4 501.3C548.4 501.3 533.3 505.6 523.9 489.4C523.9 489.4 527.5 482.2 527.8 475.5Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M525.201 486.6C526.701 483.1 527.601 479.4 527.901 475.6C527.901 475.6 544.101 481.5 562.101 479C562.101 479 561.201 487.8 556.301 494.8C556.201 494.7 539.101 502.3 525.201 486.6Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M562 478.9L560.6 485.5C549.3 488.7 537.1 487.2 526.9 481.4C527.4 479.7 527.7 478 527.8 476.2L527.9 475.6C529 475.9 544.6 481.4 562 478.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M519.301 465.7C518.701 463.4 516.301 462.2 514.101 462.8C513.901 462.9 513.601 463 513.401 463.1C508.201 465.1 510.001 475.9 517.301 477.8C521.801 478.4 521.001 475.7 520.401 472.1L519.301 465.7Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M513 466.1C513.7 465.5 514.7 465.3 515.6 465.6C516.4 465.9 517.1 466.4 517.5 467.2C518 468.2 518.3 469.3 518.2 470.4L518.3 471.3C518.4 471.6 518.2 471.9 517.9 471.9C517.6 472 517.3 471.8 517.3 471.5C517.3 471.4 517.3 471.3 517.3 471.2L517.2 470.3C517.2 469.4 517 468.5 516.7 467.6C516.4 467.1 516 466.7 515.5 466.5C514.9 466.4 514.4 466.5 513.9 466.8C513.6 466.9 513.3 466.9 513.2 466.7C512.7 466.6 512.8 466.3 513 466.1Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.7 875.8C367 794.2 360.7 788.8 360.5 788.6L360.9 787.9C361.2 788 367.8 792.1 373.6 875.8H372.7Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.6 875.8H377.8C381.5 816.2 377.5 783.7 377.4 783.3L378.2 783.2C378.2 783.6 382.3 816.2 378.6 875.8Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.7 877.6C379.2 840.4 390.7 812.1 390.8 811.8L391.6 812.1C391.5 812.4 380 840.5 384.5 877.5L383.7 877.6Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.4 882.1C386.5 868.8 386.6 855.3 388.7 842.1L389.5 842.3C387.4 855.4 387.3 868.8 389.2 882L388.4 882.1Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391 812.5L394.7 812.2C397.3 812 399.8 811.2 402.1 809.9C403.2 809.2 404.4 808.7 405.6 808.2C410.1 806.4 415.2 806.7 420.1 806.5C428.1 806.1 435.9 804.1 443.1 800.6C443.5 800.4 443.9 800.1 444.1 799.7C444.9 798.3 443.5 797.1 442.2 796.4C436 792.6 429.7 788.7 422.7 786.9C415.7 785.1 407.7 785.3 401.8 789.4C394.7 794.1 392.2 804 391 812.5Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M444.1 799.2C443.9 799.1 443.7 799 443.5 798.9L441.8 798C440.3 797.2 438.1 796 435.4 794.7C432.2 793.1 428.9 791.8 425.5 790.9C421.3 789.7 416.9 789.4 412.6 789.9C408.3 790.4 404.2 792.1 400.9 794.9C398.3 797.3 396.2 800.2 394.8 803.5C393.5 806.3 392.7 808.6 392.1 810.2C391.8 811 391.6 811.6 391.5 812C391.4 812.2 391.3 812.4 391.2 812.6C391.2 812.4 391.3 812.1 391.4 811.9C391.5 811.4 391.7 810.8 392 810C392.7 807.7 393.6 805.4 394.5 803.2C395.9 799.9 398 796.9 400.6 794.4C404 791.5 408.2 789.7 412.6 789.2C417 788.7 421.4 789.1 425.7 790.3C429.2 791.3 432.5 792.6 435.7 794.3C438.4 795.7 440.6 796.9 442.1 797.7L443.8 798.7C443.8 798.9 444 799 444.1 799.2Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M435.3 803.9C435.2 804 430.4 800.9 424.6 797C418.8 793.1 414.1 789.8 414.2 789.7C414.3 789.6 419.1 792.7 424.9 796.6C430.7 800.5 435.3 803.8 435.3 803.9Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M430.2 789.4C427.9 790 425.5 790.2 423.1 790C424.3 789.8 425.4 789.7 426.6 789.7C427.8 789.5 429 789.4 430.2 789.4Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M409.2 786.7C408.8 787.6 408.3 788.4 407.6 789.2C407 790 406.4 790.8 405.6 791.5C406 790.6 406.5 789.8 407.2 789C407.7 788.1 408.4 787.3 409.2 786.7Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M413.5 806.7C412.7 806.4 411.9 805.9 411.2 805.5C409.8 804.7 407.9 803.4 405.9 802C403.9 800.6 402.1 799.2 400.9 798.2C400.2 797.7 399.5 797.1 398.9 796.5C399.7 796.9 400.4 797.4 401.1 797.9L406.2 801.6C408.2 803.1 410 804.3 411.4 805.2C412.1 805.7 412.8 806.2 413.5 806.7Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.9 929H364.6L357.9 879.2H407.7L400.9 929Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.9 886.8H353.6L352.8 875.8H412.8L411.9 886.8Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M358.9 886.8H406.6L400.9 929L395.2 928.6L398.4 890.1L359.3 889.5L358.9 886.8Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M399.4 875.9L397.7 886.8H411.9L412.8 875.8L399.4 875.9Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.3 899.3H361.1V900.1H404.3V899.3Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.3 902.7H361.1V903.5H404.3V902.7Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.4 788.2C357.9 785.5 354.2 785 349.8 785.2C345.4 785.5 341.1 786.6 337.1 788.5C330.2 791.5 323.8 795.9 319.7 802.2C315.6 808.5 314.2 816.7 317.2 823.6C317.4 824.3 317.9 824.9 318.6 825.3C319.4 825.5 320.2 825.5 320.9 825.1C328.7 822.6 336.5 820 343.7 816C350.9 812 357.4 806.5 361.2 799.2C362.2 797.5 362.8 795.6 363 793.6C363.4 791.7 362.8 789.7 361.4 788.2Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M361.5 787.4C361.3 787.5 361.1 787.6 360.9 787.6L359.3 788.2L358.1 788.6C357.7 788.8 357.2 788.9 356.7 789.1C355.7 789.5 354.6 789.9 353.4 790.5L351.5 791.4C350.8 791.7 350.2 792.1 349.5 792.4C348.1 793.1 346.7 794 345.1 794.9C341.9 796.9 338.8 799.2 335.9 801.7C333 804.2 330.3 807 327.9 810C326.8 811.4 325.8 812.7 324.9 814C324.5 814.7 324 815.2 323.6 815.9L322.5 817.7C321.8 818.8 321.2 819.9 320.7 820.8C320.5 821.3 320.2 821.7 320 822.1C319.8 822.5 319.6 822.9 319.5 823.2L318.7 824.7C318.6 824.9 318.5 825.1 318.4 825.2C318.5 825 318.5 824.8 318.6 824.6C318.8 824.2 319 823.7 319.3 823C319.5 822.7 319.6 822.3 319.8 821.9C320 821.5 320.2 821.1 320.5 820.6C321 819.7 321.5 818.6 322.2 817.4L323.3 815.6C323.7 815 324.1 814.4 324.6 813.7C325.5 812.4 326.5 811 327.6 809.6C332.4 803.6 338.3 798.4 344.9 794.4C346.4 793.5 347.9 792.6 349.3 791.9C350 791.6 350.7 791.2 351.3 790.9L353.2 790.1C354.4 789.5 355.6 789.2 356.6 788.8C357.1 788.6 357.6 788.4 358 788.3L359.2 787.9L360.9 787.4C361.1 787.5 361.3 787.4 361.5 787.4Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M334.2 802.2C331.4 803.3 328.6 804.2 325.7 804.9C322.9 805.8 320 806.6 317.1 807.2C319.9 806.1 322.7 805.2 325.6 804.5C328.4 803.6 331.3 802.8 334.2 802.2Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M333.9 821C333.7 820.1 333.7 819.2 333.7 818.3C333.7 816.7 333.7 814.4 333.7 811.9C333.7 809.4 333.9 807.1 334 805.5C334 804.6 334.1 803.7 334.3 802.9C334.4 803.8 334.4 804.7 334.3 805.6C334.3 807.4 334.2 809.6 334.1 812C334 814.4 334 816.6 333.9 818.4C334 819.2 333.9 820.1 333.9 821Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M349.9 812.8C349.8 812.8 349.3 808.2 348.9 802.5C348.5 796.8 348.3 792.2 348.4 792.2C348.5 792.2 349 796.8 349.4 802.5C349.8 808.2 350.1 812.8 349.9 812.8Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M329.9 791.8C330.8 791.7 331.7 791.7 332.6 791.7C334.3 791.7 336.6 791.8 339.2 791.9C341.8 792 344.1 792.1 345.7 792.2C346.6 792.2 347.5 792.3 348.4 792.5C347.5 792.6 346.6 792.6 345.7 792.6C344 792.6 341.7 792.5 339.1 792.4C336.5 792.3 334.2 792.2 332.6 792.1C331.7 792 330.8 791.9 329.9 791.8Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.4 770.5C352.9 773.2 351.4 775.9 349.9 778.7C349.8 778.9 349.7 779.1 349.4 779.1C349.1 779.1 349 778.9 348.9 778.7L337 760.4L339.7 758.8L354.4 770.5Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M354.4 770.5C352.9 773.2 351.4 775.9 349.9 778.7C349.8 778.9 349.7 779.1 349.4 779.1C349.1 779.1 349 778.9 348.9 778.7L337 760.4L339.7 758.8L354.4 770.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.6 785.2L338 761.2C337.6 761 337.1 760.7 337 760.2C336.9 759.7 337.3 759 337.7 758.6C343.4 752.7 351.3 749.6 359.4 750.1C367.6 750.7 374.9 755.3 379 762.3C382.9 769.3 383 778.5 378.6 785.2Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M343.8 753.6C344 753.6 344.2 753.5 344.3 753.5C344.7 753.5 345.2 753.4 345.8 753.4C347.7 753.4 349.6 753.5 351.4 753.8C364.1 755.9 374.3 765.2 377.7 777.6C378.2 779.4 378.5 781.3 378.7 783.2C378.8 783.9 378.7 784 378.8 784.4C378.8 784.7 378.7 785 378.5 785.3C378.6 784.6 378.6 784 378.6 783.3C378.4 781.4 378 779.6 377.5 777.8C373.3 763.7 360.6 754 345.9 753.7C344.5 753.7 343.8 753.7 343.8 753.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M373.1 768.7C372.5 769.1 371.8 769.4 371.1 769.6C369.8 770.1 368 770.8 366 771.4C364 772 362.1 772.6 360.8 772.9C360.1 773.1 359.3 773.3 358.6 773.3C359.3 773 360 772.7 360.7 772.5L365.9 770.9L371.1 769.2C371.6 769 372.3 768.8 373.1 768.7Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M366.7 751.5C367.1 753 367.2 754.5 367.2 756C367.3 757.5 367.2 759.1 367 760.5C366.8 759 366.7 757.5 366.8 756C366.5 754.5 366.5 753 366.7 751.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M337.6 760.8C338.5 760.4 339.5 760 340.6 759.8C342.5 759.2 345 758.5 347.9 757.8C350.8 757.1 353.4 756.6 355.3 756.2C356.3 756 357.4 755.8 358.4 755.8C357.4 756.1 356.4 756.4 355.4 756.6C353.5 757 350.9 757.6 348.1 758.3C345.3 759 342.7 759.6 340.8 760.1C339.7 760.4 338.6 760.6 337.6 760.8Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.5 830.599C392 829.699 387.8 833.099 387.1 836.599C386.4 840.099 387.7 843.799 389.3 846.999C392.6 854.299 397.6 860.799 403.8 865.999C410 871.099 417.8 873.999 425.9 874.099C424.4 867.199 426.3 860.099 425.5 853.099C424 840.399 414 830.499 401.3 829.099C399 828.899 396.4 828.499 395.5 830.599Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M425.9 874.1C425.7 874 425.6 874 425.4 873.9C424.9 873.6 424.5 873.4 424.1 873C422.6 871.7 421.5 870.2 420.6 868.4C420 867.3 419.4 866.1 418.8 864.8L417 860.6C416.3 859.1 415.5 857.6 414.7 856.1C413.7 854.6 412.7 853.1 411.5 851.8C409.1 849 406.5 846.6 404.3 844.2C402.3 842.2 400.5 840 398.8 837.6C397.7 836 396.8 834.3 396.1 832.5C395.9 832 395.8 831.5 395.6 831C395.5 830.8 395.5 830.6 395.5 830.5C395.5 830.5 395.7 831.2 396.3 832.5C397 834.3 398 835.9 399.1 837.5C400.8 839.8 402.6 842 404.6 844C406.8 846.3 409.4 848.7 411.8 851.6C413 853 414.1 854.4 415 856C415.9 857.5 416.6 859 417.3 860.5C417.9 862 418.6 863.4 419.1 864.7C419.6 866 420.3 867.2 420.8 868.3C421.6 870 422.7 871.6 424.1 872.9C425.2 873.8 426 874.1 425.9 874.1Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M407.8 868.4C407.8 867.6 407.9 866.8 408.1 866C408.4 864.6 408.8 862.6 409.4 860.4C410 858.2 410.7 856.3 411.2 854.9C411.4 854.1 411.7 853.4 412.2 852.7C412.1 853.5 411.9 854.2 411.6 855C411.2 856.4 410.6 858.3 410 860.5C409.4 862.7 408.9 864.6 408.5 866C408.3 866.9 408.1 867.7 407.8 868.4Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M425.2 851.5C424.4 851.4 423.5 851.2 422.7 850.9C421.2 850.5 419.1 850 416.8 849.4C414.5 848.8 412.4 848.5 410.8 848.2C410 848.1 409.1 847.9 408.3 847.7C409.1 847.7 410 847.7 410.8 847.9C412.3 848.1 414.5 848.5 416.8 849C419.1 849.5 421.2 850.1 422.7 850.6C423.6 850.9 424.4 851.2 425.2 851.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M394.8 856.5C394.8 855.6 395 854.7 395.2 853.8C395.5 852.1 396 849.8 396.7 847.3C397.4 844.8 398.1 842.5 398.6 840.9C398.9 840 399.2 839.2 399.6 838.3C399.5 839.2 399.2 840.1 398.9 841C398.4 842.6 397.8 844.9 397.1 847.4C396.4 849.9 395.9 852.2 395.5 853.8C395.4 854.7 395.1 855.6 394.8 856.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M417.2 836.9C417.2 837 412.8 836.7 407.4 836.1C404.1 835.8 400.9 835.4 397.7 834.8C397.7 834.7 402.1 835 407.5 835.6C410.8 835.8 414 836.3 417.2 836.9Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.3 796C378 792.8 374.8 790.4 371.6 790.4C368.4 790.5 365.4 792.2 363.5 794.8C361.7 797.4 360.3 800.4 359.6 803.5C357.5 811 356.3 818.9 357.2 826.6C358.1 834.3 361.3 842 366.8 847.5C367.7 848.4 368.9 849.3 370.1 849C370.8 848.8 371.4 848.4 371.9 847.9C382.9 837.8 389 823.5 388.7 808.5C388.6 805.5 388.2 802.5 386.6 800C385 797.5 381.1 795 378.3 796Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M368.5 848.6C368.5 848.4 368.4 848.2 368.4 848.1C368.4 847.7 368.4 847.2 368.3 846.5C368.2 845.1 368.2 843.2 368.3 840.7C368.4 838.2 368.5 835.4 368.8 832.2C369.1 829 369.6 825.5 370.2 821.8C370.8 818.1 371.7 814.7 372.5 811.6C373.3 808.5 374.2 805.7 375 803.4C375.8 801.1 376.5 799.3 377 798L377.6 796.5C377.7 796.3 377.7 796.2 377.8 796C377.8 796.2 377.7 796.4 377.7 796.5C377.6 796.9 377.4 797.4 377.2 798C376.7 799.3 376.1 801.1 375.3 803.4C374.5 805.7 373.7 808.5 372.9 811.6C372.1 814.7 371.3 818.1 370.6 821.8C369.9 825.5 369.5 828.9 369.1 832.1C368.7 835.3 368.6 838.2 368.5 840.6C368.4 843 368.4 845 368.4 846.3C368.4 846.9 368.4 847.5 368.4 847.9C368.6 848.2 368.6 848.4 368.5 848.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M370.6 822C370.1 822.6 369.6 823.2 369 823.8C367.9 824.8 366.5 826.3 364.8 827.8C363.1 829.3 361.5 830.6 360.3 831.5C359.7 832 359 832.5 358.3 832.9C358.8 832.3 359.4 831.8 360.1 831.3L364.5 827.5L368.8 823.7C369.3 823 369.9 822.4 370.6 822Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M383.5 832.3C382.9 831.5 382.3 830.7 381.8 829.9L377.8 824.1L373.7 818.3C373.1 817.5 372.5 816.7 372.1 815.8C372.8 816.5 373.4 817.2 374 818C375.1 819.4 376.6 821.4 378.2 823.7C379.8 826 381.2 828.1 382.1 829.7C382.6 830.6 383.1 831.5 383.5 832.3Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M376.8 799.7C376.9 799.8 372.6 802.7 367.3 806.1C362 809.5 357.6 812.2 357.5 812.1C357.4 812 361.7 809.1 367 805.7C372.3 802.3 376.7 799.6 376.8 799.7Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M388.8 812.7C384.4 808.8 380.2 804.7 376.2 800.4C378.5 802.3 380.6 804.3 382.7 806.4C384.8 808.4 386.9 810.5 388.8 812.7Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.9 902.4V928.5H383.7V902.4H381.2V928.5H355V902.4H352.5V991H355V936.1H381.2V991H383.7V936.1H409.9V991H412.4V936.1V928.5V902.4H409.9Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M409.9 902.4V928.5H383.7V902.4H381.2V928.5H355V902.4H352.5V991H355V936.1H381.2V991H383.7V936.1H409.9V991H412.4V936.1V928.5V902.4H409.9Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.9 562L1222.5 566.2L1211 570.4L1210.5 581.9C1210 594.1 1215.3 604.9 1225.8 612.6C1231.5 616.7 1237.4 619.8 1241.6 618.3C1245.8 616.8 1248.3 610.6 1249.9 603.8C1252.9 591.1 1250 579.5 1241.7 570.6L1233.9 562Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1231.7 562.8L1222.4 566.2L1213.1 569.6L1212.7 578.9C1212.3 588.8 1216.6 597.5 1225 603.7C1229.6 607.1 1234.4 609.5 1237.8 608.3C1241.2 607.1 1243.2 602.1 1244.6 596.5C1247 586.3 1244.6 576.9 1237.9 569.6L1231.7 562.8Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1229.5 563.6L1222.4 566.2L1215.3 568.8L1215 575.9C1214.7 583.5 1218 590.1 1224.4 594.9C1227.9 597.5 1231.6 599.3 1234.2 598.4C1236.8 597.5 1238.4 593.6 1239.4 589.4C1241.3 581.6 1239.4 574.4 1234.3 568.8L1229.5 563.6Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.4 564.4L1222.5 566.2L1217.6 568L1217.4 572.9C1217.1 578.1 1219.6 583.1 1223.9 586.1C1226.3 587.9 1228.9 589.2 1230.7 588.5C1232.5 587.8 1233.6 585.2 1234.3 582.3C1235.7 577.3 1234.3 571.9 1230.8 568.1L1227.4 564.4Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.1 520.1L1257.4 535.8C1257.6 535.9 1257.8 536.1 1257.9 536.3L1263.4 551.2C1263.5 551.4 1263.4 551.6 1263.2 551.6H1263.1L1243.1 551.4L1231.1 520.1Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1234.5 522.1L1245.3 551.7L1243 551.4L1231.1 520.1L1234.5 522.1Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.7 536.1L1177.8 565.1C1177.7 565.3 1177.7 565.6 1177.8 565.8L1183.3 580.7C1183.4 580.9 1183.6 581 1183.8 580.9C1183.8 580.9 1183.9 580.9 1183.9 580.8L1198.9 567.7L1187.7 536.1Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1186.2 539.9L1197.1 569.5L1198.7 567.7L1187.5 536.1L1186.2 539.9Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.9 450.6C1176.3 451.9 1173.3 463.6 1173 481.3C1172.8 491.7 1174.3 502.1 1177.4 512.1L1202.4 578.3L1219.8 571.7L1229.9 567.9L1247.3 561.3L1224.6 501.2C1222.4 495.3 1219.6 489.7 1216.3 484.3C1213 478.9 1209.3 473.8 1205.2 469.1C1193.8 455.8 1183.4 449.3 1179.9 450.6Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1179.9 450.6C1176.3 451.9 1173.3 463.6 1173 481.3C1172.8 491.7 1174.3 502.1 1177.4 512.1L1202.4 578.3L1219.8 571.7L1229.9 567.9L1247.3 561.3L1224.6 501.2C1222.4 495.3 1219.6 489.7 1216.3 484.3C1213 478.9 1209.3 473.8 1205.2 469.1C1193.8 455.8 1183.4 449.3 1179.9 450.6Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.9 450.6C1177.1 451.5 1174.7 458.9 1173.6 470.3L1197.4 460.8C1189 452.8 1183.5 449.4 1179.9 450.6Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243.72 552.284L1198.95 568.755L1199.19 569.412L1243.96 552.941L1243.72 552.284Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.23 553.688L1199.46 570.159L1199.7 570.816L1244.47 554.345L1244.23 553.688Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.7 554.994L1199.94 571.465L1200.18 572.122L1244.94 555.651L1244.7 554.994Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.21 556.392L1200.45 572.863L1200.69 573.52L1245.45 557.049L1245.21 556.392Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.73 557.791L1200.96 574.262L1201.2 574.919L1245.97 558.448L1245.73 557.791Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.2 559.096L1201.43 575.566L1201.68 576.223L1246.44 559.753L1246.2 559.096Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.71 560.498L1201.95 576.969L1202.19 577.626L1246.95 561.155L1246.71 560.498Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1215.47 535.57L1214.81 535.812L1223.48 559.368L1224.14 559.126L1215.47 535.57Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1207.92 502.115L1207.26 502.356L1219 534.265L1219.66 534.024L1207.92 502.115Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205.52 507.919C1211.87 503.131 1213.14 494.102 1208.35 487.752C1203.56 481.401 1194.53 480.134 1188.18 484.922C1181.83 489.71 1180.56 498.739 1185.35 505.089C1190.14 511.44 1199.17 512.706 1205.52 507.919Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.3 511.2C1194.3 514.2 1185.4 510.1 1182.4 502C1179.4 494 1183.5 485.1 1191.6 482.1C1199.6 479.1 1208.5 483.2 1211.5 491.3C1213.4 496.5 1212.4 502.4 1208.9 506.6C1207.1 508.7 1204.8 510.2 1202.3 511.2ZM1192.3 484.2C1185.4 486.7 1181.8 494.4 1184.3 501.3C1186.8 508.2 1194.5 511.8 1201.4 509.3C1203.6 508.5 1205.6 507.1 1207.1 505.3C1211.8 499.7 1211.1 491.3 1205.4 486.6C1202.7 484.3 1199.2 483.2 1195.7 483.5C1194.5 483.5 1193.4 483.7 1192.3 484.2Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208.3 517.5C1207.5 517.5 1206.8 516.9 1206.8 516.1C1206.8 515.9 1206.8 515.7 1206.9 515.5C1207.1 515.1 1207.4 514.9 1207.7 514.7C1208.5 514.5 1209.3 514.9 1209.5 515.7C1209.7 516.4 1209.4 517.2 1208.7 517.5C1208.6 517.4 1208.5 517.5 1208.3 517.5ZM1208.3 515.3C1207.9 515.3 1207.6 515.6 1207.6 516C1207.6 516.1 1207.6 516.2 1207.7 516.3C1207.8 516.7 1208.2 516.9 1208.6 516.8C1209 516.7 1209.2 516.3 1209.1 515.9C1209.1 515.9 1209.1 515.9 1209.1 515.8C1209 515.6 1208.9 515.5 1208.7 515.4C1208.5 515.3 1208.4 515.3 1208.3 515.3Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212.1 527.8C1211.3 527.8 1210.6 527.1 1210.6 526.3C1210.6 526.1 1210.6 525.9 1210.7 525.7C1211 525 1211.9 524.7 1212.7 525C1213 525.2 1213.3 525.5 1213.4 525.8C1213.7 526.6 1213.3 527.4 1212.5 527.7C1212.4 527.7 1212.3 527.8 1212.1 527.8ZM1212.1 525.6C1212 525.6 1211.9 525.6 1211.9 525.6C1211.7 525.7 1211.6 525.8 1211.5 526C1211.3 526.4 1211.5 526.8 1211.9 527C1212.3 527.2 1212.7 527 1212.9 526.6C1213 526.4 1213 526.2 1212.9 526C1212.6 525.7 1212.4 525.5 1212.1 525.6Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222 542C1221.2 542 1220.5 541.3 1220.6 540.5C1220.6 539.7 1221.3 539 1222.1 539.1C1222.7 539.1 1223.2 539.5 1223.4 540C1223.7 540.8 1223.3 541.6 1222.5 541.9C1222.3 541.9 1222.2 542 1222 542ZM1222 539.8C1221.9 539.8 1221.8 539.8 1221.7 539.8C1221.3 539.9 1221.1 540.4 1221.3 540.7C1221.5 541 1221.9 541.3 1222.2 541.1C1222.6 541 1222.8 540.5 1222.6 540.2C1222.5 540 1222.4 539.9 1222.2 539.8C1222.2 539.8 1222.1 539.8 1222 539.8Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.8 552.3C1225.2 552.3 1224.6 551.9 1224.4 551.3C1224.1 550.6 1224.4 549.7 1225.2 549.4C1226 549.1 1226.8 549.4 1227.1 550.2V550.3C1227.4 551.1 1227 551.9 1226.2 552.2C1226.1 552.3 1226 552.3 1225.8 552.3ZM1225.8 550.1C1225.7 550.1 1225.6 550.1 1225.6 550.1C1225.2 550.2 1225 550.7 1225.2 551C1225.3 551.2 1225.4 551.3 1225.6 551.4C1226 551.6 1226.4 551.4 1226.6 551C1226.8 550.6 1226.6 550.2 1226.2 550C1226 550.1 1225.9 550.1 1225.8 550.1Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.14 528.284L1190.69 544.258L1190.93 544.915L1234.38 528.941L1234.14 528.284Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.6 344.7L1067.5 418.6L1079.5 408L1089.8 419L1087.1 346.4L1075.6 344.7Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.4 338.1L1143.9 399.9L1128.3 396L1124.3 410.5L1093.1 345L1102.4 338.1Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1075.6 344.7L1067.5 418.6L1079.5 408L1089.8 419L1087.1 346.4L1075.6 344.7Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1102.4 338.1L1143.9 399.9L1128.3 396L1124.3 410.5L1093.1 345L1102.4 338.1Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1109 347.9C1108.4 349.1 1107.9 350.4 1107.4 351.8C1106.7 353.8 1106.1 355.6 1105 356.4C1103.9 357.2 1102 357.1 1100.1 357H1098.7L1101.5 362.8C1103.9 363 1106.3 362.4 1108.3 361.1C1110.9 359.3 1111.9 356.3 1112.8 353.7L1109 347.9Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1087.6 360.1L1086.8 360.6C1085.1 361.6 1083.5 362.7 1082.2 362.6C1080.9 362.5 1079.4 361.2 1077.8 359.9C1076.7 358.9 1075.5 358 1074.2 357.2L1073.5 363.8L1074.1 364.3C1076.2 366.1 1078.6 368.1 1081.8 368.3C1082.7 368.4 1083.6 368.3 1084.4 368.1C1085.6 367.8 1086.7 367.3 1087.8 366.7L1087.6 360.1Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122 327.8C1122.2 326.5 1122.6 325.1 1123.2 323.9C1124.3 321.3 1125.5 318.4 1124.7 315.3C1123.9 312.2 1121.5 310.1 1119.4 308.3C1118.3 307.5 1117.3 306.5 1116.5 305.4C1115.9 304.1 1115.4 302.7 1115.1 301.3C1114.4 298.6 1113.7 295.6 1111.3 293.6C1108.9 291.6 1105.8 291.4 1103 291.1C1100.1 291.3 1097.3 290.2 1095.4 288C1093.3 286.2 1090.9 284.2 1087.7 283.9C1084.5 283.6 1082 285.3 1079.7 286.7C1078.5 287.5 1077.2 288.2 1075.8 288.7C1074.3 288.9 1072.9 288.9 1071.4 288.8C1068.7 288.6 1065.6 288.4 1063 290C1060.4 291.6 1059.1 294.6 1058.1 297.2C1057.7 298.5 1057 299.8 1056.2 300.9C1055.2 301.9 1054 302.7 1052.8 303.4C1050.5 304.9 1047.8 306.5 1046.6 309.4C1045.4 312.3 1046.2 315.3 1046.8 318C1047.2 319.4 1047.4 320.8 1047.5 322.2C1047.3 323.6 1046.9 324.9 1046.3 326.1C1045.2 328.7 1044 331.6 1044.8 334.7C1045.6 337.8 1048 339.9 1050.1 341.7C1051.2 342.5 1052.2 343.5 1053 344.6C1053.7 345.9 1054.1 347.3 1054.4 348.7C1055.1 351.4 1055.8 354.4 1058.2 356.4C1060.6 358.4 1063.7 358.7 1066.5 358.9C1067.9 358.9 1069.3 359.1 1070.7 359.6C1071.9 360.2 1073.1 361.1 1074.1 362C1076.2 363.8 1078.6 365.8 1081.8 366C1082.7 366.1 1083.6 366 1084.4 365.8C1086.3 365.2 1088.1 364.3 1089.8 363.2C1092.1 361.3 1095.2 360.5 1098.1 361.2C1100.8 361.4 1103.9 361.6 1106.5 360C1109.1 358.4 1110.4 355.4 1111.4 352.8C1112.1 350 1114 347.7 1116.7 346.6C1119 345.1 1121.7 343.5 1122.9 340.6C1124.1 337.7 1123.3 334.7 1122.7 332C1122.2 330.6 1122 329.2 1122 327.8Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1122 327.8C1122.2 326.5 1122.6 325.1 1123.2 323.9C1124.3 321.3 1125.5 318.4 1124.7 315.3C1123.9 312.2 1121.5 310.1 1119.4 308.3C1118.3 307.5 1117.3 306.5 1116.5 305.4C1115.9 304.1 1115.4 302.7 1115.1 301.3C1114.4 298.6 1113.7 295.6 1111.3 293.6C1108.9 291.6 1105.8 291.4 1103 291.1C1100.1 291.3 1097.3 290.2 1095.4 288C1093.3 286.2 1090.9 284.2 1087.7 283.9C1084.5 283.6 1082 285.3 1079.7 286.7C1078.5 287.5 1077.2 288.2 1075.8 288.7C1074.3 288.9 1072.9 288.9 1071.4 288.8C1068.7 288.6 1065.6 288.4 1063 290C1060.4 291.6 1059.1 294.6 1058.1 297.2C1057.7 298.5 1057 299.8 1056.2 300.9C1055.2 301.9 1054 302.7 1052.8 303.4C1050.5 304.9 1047.8 306.5 1046.6 309.4C1045.4 312.3 1046.2 315.3 1046.8 318C1047.2 319.4 1047.4 320.8 1047.5 322.2C1047.3 323.6 1046.9 324.9 1046.3 326.1C1045.2 328.7 1044 331.6 1044.8 334.7C1045.6 337.8 1048 339.9 1050.1 341.7C1051.2 342.5 1052.2 343.5 1053 344.6C1053.7 345.9 1054.1 347.3 1054.4 348.7C1055.1 351.4 1055.8 354.4 1058.2 356.4C1060.6 358.4 1063.7 358.7 1066.5 358.9C1067.9 358.9 1069.3 359.1 1070.7 359.6C1071.9 360.2 1073.1 361.1 1074.1 362C1076.2 363.8 1078.6 365.8 1081.8 366C1082.7 366.1 1083.6 366 1084.4 365.8C1086.3 365.2 1088.1 364.3 1089.8 363.2C1092.1 361.3 1095.2 360.5 1098.1 361.2C1100.8 361.4 1103.9 361.6 1106.5 360C1109.1 358.4 1110.4 355.4 1111.4 352.8C1112.1 350 1114 347.7 1116.7 346.6C1119 345.1 1121.7 343.5 1122.9 340.6C1124.1 337.7 1123.3 334.7 1122.7 332C1122.2 330.6 1122 329.2 1122 327.8Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084.8 357.3C1067 357.3 1052.5 342.8 1052.5 325C1052.5 307.2 1067 292.7 1084.8 292.7C1099.6 292.7 1112.6 302.8 1116.1 317.2C1120.4 334.5 1109.8 352 1092.5 356.3C1090 357 1087.4 357.3 1084.8 357.3ZM1084.9 294.7C1068.1 294.7 1054.5 308.2 1054.5 325C1054.5 341.8 1068 355.4 1084.8 355.4C1101.6 355.4 1115.2 341.9 1115.2 325.1C1115.2 322.6 1114.9 320.2 1114.3 317.8C1110.9 304.2 1098.8 294.7 1084.9 294.7Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080.8 309L1088.7 318.3L1100.7 317.1L1094.3 327.4L1099.1 338.5L1087.4 335.6L1078.3 343.6L1077.5 331.5L1067 325.4L1078.2 320.8L1080.8 309Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.4 638.1L326.9 659.5C326.4 659.7 325.9 659.4 325.7 658.9L298 573C297.9 572.5 298.1 572 298.6 571.8L348.4 555.7L371.4 566.7L393.9 636.9C394.2 637.4 393.9 638 393.4 638.1Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M393.4 638.1L326.9 659.5C326.4 659.7 325.9 659.4 325.7 658.9L298 573C297.9 572.5 298.1 572 298.6 571.8L348.4 555.7L371.4 566.7L393.9 636.9C394.2 637.4 393.9 638 393.4 638.1Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.891 569.697L311.542 586.41L312.316 588.787L363.664 572.074L362.891 569.697Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.292 577.323L313.943 594.036L314.717 596.413L366.066 579.7L365.292 577.323Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.786 584.913L316.438 601.626L317.211 604.003L368.56 587.29L367.786 584.913Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.289 591.801L318.951 608.552L319.727 610.929L371.064 594.178L370.289 591.801Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.781 600.099L321.433 616.812L322.206 619.19L373.555 602.477L372.781 600.099Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.191 607.021L323.854 623.771L324.629 626.148L375.967 609.397L375.191 607.021Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.681 615.317L326.332 632.03L327.106 634.408L378.454 617.695L377.681 615.317Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.19 622.204L328.853 638.955L329.628 641.332L380.966 624.581L380.19 622.204Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.5 555.8L371.5 566.8L354.8 572.2C354.3 572.3 353.8 572.1 353.6 571.6L348.5 555.8Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M348.5 555.8L371.5 566.8L354.8 572.2C354.3 572.3 353.8 572.1 353.6 571.6L348.5 555.8Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout1);
export default __webpack_public_path__ + "static/media/about1.34d1214b9d647a55b89c72b52fdf65e0.svg";
export { ForwardRef as ReactComponent };